const ALL_ROUTES = {
  HOME: '/',
  PUBLIC_BUDGET: '/public/budget/:token',
  PUBLIC_BUDGET_EMBED: '/public/budget/:token/embed',
  AUTH: '/auth',
  AUTH_CHILDREN: {
    LOGIN: '/auth/login',
    SIGNUP: '/auth/signup',
    FORGOT_PASSWORD: '/auth/forgot-password',
  },
  HOME_SCREEN: '/home',
  HOME_SCREEN_CHILDREN: {
    ACCOUNT_SETTINGS: '/home/settings/account',
    PRINT_BUDGET: '/home/print-budget',
    FRINGES_DETAILS: '/home/fringes-listing',
    GLOBALS_DETAILS: '/home/globals-listing',
    TAGS_DETAILS: '/home/tags-listing',
    CREDITS_DETAILS: '/home/credits-listing',
  },
  BUDGET_DETAILS: '/home/budget-listing',
  FRINGES_DETAILS: '/home/fringes-listing',
  GLOBALS_DETAILS: '/home/globals-listing',
  TAGS_DETAILS: '/home/tags-listing',
  CREDITS_DETAILS: '/home/credits-listing',
  ACCOUNT_SETTINGS_CHILDREN: {
    PROFILE: '/home/settings/account/profile',
    PAYMENTS: '/home/settings/account/payments',
    SUBSCRIPTION: '/home/settings/account/subscription',
    NOTIFICATIONS: '/home/settings/account/notifications',
    SECURITY: '/home/settings/account/security',
    CONTACT_US: '/home/settings/account/contact-us',
    INVITE_FRIENDS: '/home/settings/account/invite-friends',
    SUPPORT_FEEDBACK: '/home/settings/account/support-feedback',
    PRIVACY_POLICY: '/home/settings/account/privacy-policy',
    TERMS_CONDITIONS: '/home/settings/account/terms-conditions',
    FAQS: '/home/settings/account/faqs',
  },
};

export default ALL_ROUTES;
